import styled from "styled-components";

export const Banner = styled.div`
  height: 400px;
  background-image: url("img/header.jpeg");
  background-position: center;
  background-size: cover;
  filter: contrast(75%);
}
`;
